import React, { useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setId,
  setLink,
  setHash,
  setError,
  setErrorFile,
} from "../../redux/slices/getQrLinkSlice";
import { resetSaveValue } from "../../redux/slices/saveValue";
import { categoryNameAction } from "../../redux/slices/selectCategories";
import { ContextAll } from "../../components/saveFile/saveFile";
import CardTypeQr from "./cardTypeQr";
import Navigation from "../../components/navigation";
import { resetBuilder } from "../../redux/slices/linksBuilder";
import { forceToggle } from "../../redux/slices/forceСreate";
import { resetMultiUrl } from "../../redux/slices/multiUrl";
import { linkStep } from "../../redux/slices/navigation";
import useTypeDecription from "../../hooks/useTypeDecription";
import { webView } from "../../variables/webView";
import HeaderWebview from "./HeaderWebview";
import { resetBooking } from "../../redux/slices/booking";
import useCurrentLocation from "../../hooks/useCurrentLocation";
import {
  qrCornetsInterior,
  qrCornetsOuter,
  qrPattern,
} from "../../redux/slices/qrSettings";
import { setDesignType } from "../../redux/slices/customizeQr";
import { designTypes } from "../../constants/common";

export default function FirstScreen() {
  const pageCounter = useSelector((state) => state.navigation.pageCounter);
  const firstPageSearchValue = useSelector(
    (state) => state.saveValue.firstPageSearchValue
  );
  const dispatch = useDispatch();
  const { showFooter, hideFooter } = useTypeDecription();
  const { isArtQr } = useCurrentLocation();

  const {
    setSavePdf,
    setSaveAudio,
    setSavePptx,
    setSaveGallery,
    setSavePcr,
    setSaveWifi,
    setSaveText,
    setSaveVCardFile,
  } = useContext(ContextAll);
  useEffect(() => {
    if (pageCounter === 1) {
      showFooter();
      dispatch(setId(null));
      dispatch(setLink(""));
      dispatch(setHash(null));
      dispatch(setError(null));
      dispatch(setErrorFile(null));
      setSavePdf();
      setSaveAudio();
      setSavePptx();
      setSaveGallery();
      setSavePcr(["", "", ""]);
      setSaveWifi();
      setSaveText("");
      setSaveVCardFile();
      dispatch(categoryNameAction(""));
      dispatch(resetBuilder());
      dispatch(resetSaveValue());
      dispatch(forceToggle(false));
      dispatch(resetMultiUrl());
      dispatch(resetBooking());
      dispatch(linkStep(false));
      if (webView) {
        document.querySelector("#head-menu")?.classList.add("d-none");
      }
    }
    return () => {
      hideFooter();
      if (webView) {
        document.querySelector("#head-menu")?.classList.remove("d-none");
      }
    };
  }, [pageCounter]);

  useEffect(() => {
    if (isArtQr) {
      dispatch(setDesignType(designTypes.art));
      dispatch(qrPattern("small-dots"));
      dispatch(qrCornetsOuter("square"));
      dispatch(qrCornetsInterior("square"));
    }

    const modalApps = document.querySelector(".modal-apps");
    if (
      modalApps &&
      !JSON.parse(localStorage.getItem("isClosedApps")) &&
      !webView
    ) {
      modalApps?.classList.remove("d-none");
    }
  }, []);
  return (
    <>
      {webView && pageCounter === 1 && <HeaderWebview />}
      {!(webView && firstPageSearchValue.length > 0) && <Navigation />}
      <CardTypeQr />
    </>
  );
}
